import { combineEpics } from "redux-observable";
import { epicShopGrantRewardReceived } from "./epics/epicShopGrantRewardReceived";
import { epicShopInitialRequest } from "./epics/epicShopInitialRequest";
import { epicShopInitialShiftLevelRequest } from "./epics/epicShopInitialShiftLevelRequest";
import { epicShopOfferDeselect } from "./epics/epicShopOfferDeselect";
import { epicShopOpenOffer } from "./epics/epicShopOpenOffer";
import { epicShopPaymentEntryRequest } from "./epics/epicShopPaymentEntryRequest";
import { epicShopPurchaseRequest } from "./epics/epicShopPurchaseRequest";
import { epicShopUpdateCatalog } from "./epics/epicShopUpdateCatalog";
import { epicShopUpdateOfferCharacteristics } from "./epics/epicShopUpdateOfferCharacteristics";
import { epicShopUpdateShiftLevel } from "./epics/epicShopUpdateShiftLevel";
export var epicShop = combineEpics(epicShopInitialRequest, epicShopInitialShiftLevelRequest, epicShopPaymentEntryRequest, epicShopUpdateCatalog, epicShopUpdateShiftLevel, epicShopUpdateOfferCharacteristics, epicShopOpenOffer, epicShopOfferDeselect, epicShopPurchaseRequest, epicShopGrantRewardReceived);



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/epicShop.ts
// module id = 2334
// module chunks = 3